<template>
    <div class="admin-config-page">
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{ trans('instance.instance') }}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Control tenant instance maintenance messaging and access exceptions.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="instance"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner">
                    <form @submit.prevent="submit" @keydown="configForm.errors.clear($event.target.name)">
                        <section class="admin-config-section" :aria-label="trans('instance.instance')">
                            <h4 class="admin-config-section__title">{{ trans('instance.instance') }}</h4>
                            <p class="admin-config-section__description">Instance maintenance settings affect tenant access. Add an exclusion list before enabling maintenance when admins need continued access.</p>
                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label for="">{{trans('configuration.instance_maintenance_mode')}}</label>
                                    <div>
                                        <switches class="" v-model="configForm.instance_maintenance_mode" name="instance_maintenance_mode" theme="bootstrap" color="success"></switches>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4 form-group" v-if="configForm.instance_maintenance_mode">
                                    <label for="">{{trans('configuration.instance_maintenance_mode_message')}}</label>
                                    <autosize-textarea rows="2" name="instance_maintenance_mode_message" :placeholder="trans('configuration.instance_maintenance_mode_message')" v-model="configForm.instance_maintenance_mode_message"></autosize-textarea>
                                    <show-error :form-name="configForm" prop-name="instance_maintenance_mode_message"></show-error>
                                </div>
                                <div class="col-12 col-md-4 form-group" v-if="configForm.instance_maintenance_mode">
                                    <label for="">{{trans('configuration.instance_maintenance_exclude_ip')}} <show-tip module="configuration" tip="tip_instance_maintenance_exclude_ip" type="field"></show-tip></label>
                                    <autosize-textarea rows="2" name="instance_maintenance_exclude_ip" :placeholder="trans('configuration.instance_maintenance_exclude_ip')" v-model="configForm.instance_maintenance_exclude_ip"></autosize-textarea>
                                    <show-error :form-name="configForm" prop-name="instance_maintenance_exclude_ip"></show-error>
                                </div>
                            </div>
                        </section>
                        <div class="admin-config-actions">
                            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{trans('general.save')}}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import configurationSidebar from '../system-config-sidebar'
    import switches from 'vue-switches'
    import autosizeTextarea from '../../../components/autosize-textarea'

    export default {
        components : { configurationSidebar,switches,autosizeTextarea },
        data() {
            return {
                configForm: new Form({
                    config_type: '',
                    instance_maintenance_mode: '',
                    instance_maintenance_mode_message: '',
                    instance_maintenance_exclude_ip: ''
                },false)
            }
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            axios.get('/api/configuration')
                .then(response => response.data)
                .then(response => {
                    this.configForm = helper.formAssign(this.configForm, response);
                }).catch(error => {
                    helper.showDataErrorMsg(error);
                });
        },
        methods: {
            submit(){
                this.configForm.config_type = 'instance';
                this.configForm.instance_maintenance_mode = (this.configForm.instance_maintenance_mode) ? 1 : 0;
                this.configForm.trial_period_days = (this.configForm.enable_trial_period) ? this.configForm.trial_period_days : 0;
                this.configForm.post('/api/configuration')
                    .then(response => {
                        this.$store.dispatch('setConfig',this.configForm);
                        toastr.success(response.message);
                    }).catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
